<template>
    <div v-if="isVisible">
        <button class="btn btn-primary btn-block" :disabled="isLoading" @click="prepareCheckout()">
            {{ label }}
        </button>
        <div v-if="failed" class="alert alert-danger m-t-1">
            Error while trying to prepare payment
        </div>
    </div>
</template>

<script>

    import ReInitBaseComponent from './ReInitBaseComponent';

    export default {
        extends: ReInitBaseComponent
    }
</script>

<style scoped>
    button {
        margin-top: 0.5rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/ReInitPaymentButton.vue